import { createAction } from 'redux-actions'

import * as constants from './constants'

export const getApiKeyForOrg = createAction(constants.GET_API_KEY_FOR_ORG)
export const getApiKeyForOrgPending = createAction(constants.GET_API_KEY_FOR_ORG_PENDING)
export const getApiKeyForOrgFailed = createAction(constants.GET_API_KEY_FOR_ORG_FAILED)
export const getApiKeyForOrgSuccess = createAction(constants.GET_API_KEY_FOR_ORG_SUCCESS)

export const createApiKeyForOrg = createAction(constants.CREATE_API_KEY_FOR_ORG)
export const createApiKeyForOrgSuccess = createAction(constants.CREATE_API_KEY_FOR_ORG_SUCCESS)
export const createApiKeyForOrgFailed = createAction(constants.CREATE_API_KEY_FOR_ORG_FAILED)
export const createApiKeyForOrgPending = createAction(constants.CREATE_API_KEY_FOR_ORG_PENDING)


// WEBPACK FOOTER //
// ./src/modules/apiKey/actions.js